/**
 * Pure helpers for server-side list pagination (Vuetify 2 v-data-table).
 * CommonJS so Node 16 can require this in tests without Babel.
 */
function buildPaginationParams(options, extra) {
  if (!options) options = {}
  if (!extra) extra = {}

  var page = options.page || 1
  var itemsPerPage = options.itemsPerPage || 10
  var params = Object.assign(
    {
      page: page,
      limit: itemsPerPage === -1 ? 100 : itemsPerPage,
    },
    extra
  )

  if (options.sortBy && options.sortBy.length) {
    params.sortBy = options.sortBy[0]
    params.sortDesc = !!(options.sortDesc && options.sortDesc[0])
  }

  if (params.search === '' || params.search == null) {
    delete params.search
  }

  return params
}

module.exports = {
  buildPaginationParams: buildPaginationParams,
}
